let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d765r")).then(() => parcelRequire('6MBBj'));